import React, { useEffect, useRef, useState } from "react";
import {
  Row,
  Col,
  Form,
  Container,
  Button,
  FormGroup,
  Alert,
} from "react-bootstrap";
import { connect } from "react-redux";
import { isEmpty, isNull, upperCase, uniqBy } from "lodash";
import Spinner from "react-bootstrap/Spinner";
import MaterialTable from "material-table";
import "jspdf-autotable";

import Select from "react-select";
import Swal from "sweetalert";
import { deleteSalaryIncrement, getSalaryIncrement } from "./salary.actions";
import { baseURL, headers } from "../../../../../global/api";
import { appendNonSignificantZeros } from "../../../../../global/globalFunctions";
import { setHeading } from "../../../accounts/account.actions";

const SalaryIncrementList = (props) => {
  const tableRef = useRef();
  function updateTableQuery () {
    tableRef.current.onQueryChange()
  };
  useEffect(() => {
    // props.getSalaryIncrement();
    props.setHeading("Salary Increment List")
    console.log("iiiiiiiiiiiiiiiiii");
  }, []);
  return (
    <>
      {props.isFetchingDivisionData ? (
        <div className="loader-div">
          <Button variant="info" disabled>
            <Spinner
              animation="grow"
              size="sm"
              role="status"
              aria-hidden="true"
              variant="info"
            />
            {/* {props.isFetchingwareHouseList ? 'Loading...' : 'Loading...'} */}
          </Button>
        </div>
      ) : (
        <Container fluid>
          <div className="main">
            <div>
              <Form>
                <MaterialTable
                  title="Increment/Decrement"
                  columns={uniqBy(
                    [
                      // {
                      //   title: "Employee Id",
                      //   field: "employee_id",
                      //   // render: (rowData) =>
                      //   //   appendNonSignificantZeros(rowData.employee_id),
                      // },
                      { title: "Employee Name", field: "employeeDetails.employeeName" },
                      // { title: 'Increment Id', field: 'increment_id' },
                      {
                        title: "Value",
                        field: "value",
                        // render: (rowData) =>
                        //   isNull(rowData.increment_value)
                        //     ? "-"
                        //     : rowData.increment_value,
                      },
                      {
                        title: "Type",
                        field: "type",
                        // render: (rowData) =>
                        //   isNull(rowData.decrement_value)
                        //     ? "-"
                        //     : rowData.decrement_value,
                      },
                      { title: "Date", field: "date" },
                      {
                        title: "Merge Status",
                        field: "isMerge",
                        render: (rowData) =>
                          rowData.isMerge ? "Merged" : "Unmerged",
                      },
                    ],
                    "title"
                  )}
                  data={
                    // incDecData
                    (query) =>
                      new Promise((resolve, reject) => {
                        let url = `${baseURL}/salaryIncrement?`;
                        url += "size=" + query.pageSize;
                        url += "&page=" + query.page;
                        url += "&search=" + query.search;
                        fetch(url, {
                          method: "GET",
                          headers: headers,
                        })
                          .then((response) => response.json())
                          .then((result) => {
                            resolve({
                              data: result.data,
                              page: result.page ,
                              totalCount: result.total_results,
                            });
                          });
                      })
                  }
                  options={{
                    actionsColumnIndex: -1,
                    // filtering: true,
                    exportButton: true,
                    exportAllData: true,
                    paging: true,
                    pageSize: 50, // make initial page flavors
                    emptyRowsWhenPaging: false, // To avoid of having empty rows
                    pageSizeOptions: [30, 50, 100, 150, 200], // rows selection options
                    headerStyle: {
                      position: "sticky",
                      top: 0,
                      color: "#00BBBB",
                      fontWeight: "550",
                      onRowAdd: "none",
                    },
                  }}
                  // actions={[
                  //     (rowData) => {
                  //         return { icon: EditIcon, disabled: false }
                  //     },
                  // ]}
                  editable={{
                    isEditable: false,
                    isDeletable:(rowData)=>rowData.isMerge==true?false:true,
                    // onRowUpdate: (newData, oldData) =>
                    //     new Promise((resolve) => {
                    //         setTimeout(() => {
                    //             resolve();
                    //             if (oldData) {
                    //                 props.HRUpdateEmployee(newData, oldData)

                    //             }
                    //         }, 600);
                    //     }),
                    onRowDelete: (oldData) =>
                      new Promise((resolve) => {
                        setTimeout(() => {
                          resolve();
                          props.deleteSalaryIncrement(oldData,updateTableQuery);
                        }, 600);
                      }),
                  }}
                />
              </Form>
            </div>
          </div>
        </Container>
      )}
    </>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    getSalaryIncrement: () => dispatch(getSalaryIncrement()),
    deleteSalaryIncrement: (data,updateTableQuery) => dispatch(deleteSalaryIncrement(data,updateTableQuery)),
    setHeading: (data) => dispatch(setHeading(data)),
  };
};
const mapStateToProps = (state, ownProps) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SalaryIncrementList);
